import { apiService } from './apiService';

export const driverIncidentReportService = {
  async getReports(params?: { driverId?: string; status?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.driverId) queryParams.append('driverId', params.driverId);
    if (params?.status) queryParams.append('status', params.status);
    const query = queryParams.toString();
    return apiService.get(`/driver-incident-reports${query ? `?${query}` : ''}`);
  },

  async createReport(data: any) {
    return apiService.post('/driver-incident-reports', data);
  },

  async updateReport(id: string | number, data: any) {
    return apiService.put(`/driver-incident-reports/${id}`, data);
  },

  async updateStatus(id: string | number, status: 'todo' | 'in_progress' | 'service_notified' | 'completed') {
    return apiService.put(`/driver-incident-reports/${id}/status`, { status });
  },

  async deleteReport(id: string | number) {
    return apiService.delete(`/driver-incident-reports/${id}`);
  },
};
